import React, { Component } from "react";

import ClientAPI from "../service/ClientAPI";
import AdminAPI from "../service/AdminAPI";
import Searchbar from "../components/Searchbar";
import LocalStorageManager from "../managers/LocalStorageManager";
import MyProductsTable from "../components/MyProductsTable";
import CustomerProductsTable from "../components/CustomerProductsTable";
import Events from '../service/Events';

import 'react-calendar/dist/Calendar.css';
import { Button, Box, Paper, Chip, Fade, IconButton, Menu, MenuItem, ListItemIcon, ListItemText, TextField, InputAdornment } from "@mui/material";
import { FileDownload, DeleteOutline, GetApp, CheckCircle, MoreVert, Search, PersonAdd } from '@mui/icons-material';
import CreateUserPopup from "../components/CreateUserPopup";
import BulkDownloadSheetPopup from "../components/BulkDownloadSheetPopup";

class DashboardAlleKunden extends Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            allOrders: [],
            searchUserInTable: null,
            searchProduct: null,
            searchUser: null,
            userOrders: [],
            createProduct: false,
            createUser: false,
            showDateTable: false,
            updateStartDate: false,
            updateEndDate: false,
            startDate: props.start,
            endDate: props.end,
            downloadingExcel: false,
            showBulkDownload: false,
            selectedCustomers: [],
            anchorEl: null
        };

        this.isAdmin = LocalStorageManager.Get("admin") === "1";
        this.customerTableRef = React.createRef();
    }

    handleCustomerSelectionChange = (selectedCustomers) => {
        this.setState({ selectedCustomers });
    }

    openBulkDownloadFromParent = () => {
        this.setState({ showBulkDownload: true });
    }

    handleMenuOpen = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleMenuClose = () => {
        this.setState({ anchorEl: null });
    }


    componentDidMount() {
        if (!this.isAdmin) {
            ClientAPI.GetOrders()
                .then((_orders) => {
                    this.setState({ userOrders: _orders });
                })
                .catch(console.error);

            return;
        }

        ClientAPI.RequestProducts()
            .then((_data) => {
                AdminAPI.FetchUserOrders()
                    .then(_allOrders => {
                        ClientAPI.GetOrders()
                            .then(_orders => {
                                this.setState({ products: _data, allOrders: _allOrders, userOrders: _orders })
                            })
                    })
                    .catch(console.error);
            })
            .catch(console.error);
    }

    RenderProductsOfUser = (admin = false) => {
        return (
            admin ?
                (
                    <div style={{ maxWidth: "80%", margin: "auto" }}>
                        <h3 id="myorders" style={{ textAlign: "center", marginTop: "20px" }}>Meine Bestellungen</h3>
                        <br />
                        <MyProductsTable orders={this.state.userOrders} />
                    </div>
                )
                :
                (
                    <div style={{ minHeight: "100vh", maxWidth: "80%", margin: "auto" }}>
                        <h3 id="myorders" style={{ textAlign: "center", marginTop: "20px" }}>Meine Bestellungen</h3>
                        <br />
                        <MyProductsTable orders={this.state.userOrders} />
                    </div>
                )
        );
    }

    RetrieveExcelFile = () => {
        this.setState({ downloadingExcel: true });

        // Get all customers with orders for the download
        const customersWithOrders = this.state.allOrders
            .filter(customer => !customer.isPending && customer.orders && customer.orders.length > 0);
        
        if (customersWithOrders.length === 0) {
            Events.onResult.emit('warning', 'Keine Kunden mit Bestellungen gefunden.');
            this.setState({ downloadingExcel: false });
            return;
        }

        const customerIDs = customersWithOrders.map(c => c.userID);

        // Download with separate sheets per user, vertical layout
        AdminAPI.RequestBulkExcelSheet(customerIDs, 'vertical', true)
            .then((blob) => {
                // Create blob link to download
                const url = window.URL.createObjectURL(
                    new Blob([blob]),
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute(
                    'download',
                    `Customers_separate_${new Date().toISOString().split('T')[0]}.ods`,
                );

                // Append to html link element page
                document.body.appendChild(link);

                // Start download
                link.click();

                // Clean up and remove the link
                link.parentNode.removeChild(link);

                Events.onResult.emit('success', 'Excel-Datei erfolgreich heruntergeladen!');
                this.setState({ downloadingExcel: false });
            })
            .catch((e) => {
                console.error(e);
                Events.onResult.emit('error', 'Fehler beim Herunterladen der Datei');
                this.setState({ downloadingExcel: false });
            });
    }

    DeleteAllOrders = () => {
        Events.onAlert.emit("warning", "Möchten Sie alle Bestellungen von allen Kunden löschen?", "Wenn Sie alle Bestellungen löschen, werden alle Bestellungen gelöscht und zurückgesetzt, keine Kunde hat dann noch Bestellungen!"
            , () => {
                AdminAPI.DeleteAllOrders()
                    .then(() => window.location.reload())
            })
    }

    ConfirmAllOpenOrders = () => {
        Events.onAlert.emit("warning", "Möchten Sie alle offenen Bestellungen bestätigen?", "Wenn Sie alle offenen Bestellungen bestätigen, werden alle noch nicht bestätigten Bestellungen als bestätigt markiert!"
            , () => {
                AdminAPI.ConfirmAllOpenOrders()
                    .then(() => {
                        Events.onResult.emit('success', "Alle offenen Bestellungen wurden bestätigt");
                        window.location.reload();
                    })
                    .catch((error) => {
                        Events.onResult.emit('error', "Fehler beim Bestätigen der Bestellungen");
                        console.error(error);
                    });
            })
    }

    FilterUsers = () => {
        if (!this.state.searchUserInTable) {
            return this.state.allOrders;
        }

        const searchPattern = this.state.searchUserInTable.toLowerCase();

        return this.state.allOrders
            .filter(_user => {
                if (`${_user.firstName} ${_user.lastName}`.toLowerCase().includes(searchPattern)) {
                    return true;
                }

                if (_user.email && _user.email.toLowerCase().includes(searchPattern)) {
                    return true;
                }

                return false;
            });
    }

    render() {
        return (
            <div style={{ minHeight: "95vh", paddingBottom: window.innerWidth < 600 ? "40px" : "80px" }}>
                <h3 id="tables" style={{ 
                    textAlign: "center", 
                    marginTop: window.innerWidth < 600 ? "20px" : "35px", 
                    marginBottom: window.innerWidth < 600 ? "20px" : "30px",
                    fontSize: window.innerWidth < 600 ? "1.5rem" : window.innerWidth < 900 ? "1.8rem" : "2.2rem",
                    fontWeight: 700,
                    color: "#2e7d32",
                    padding: window.innerWidth < 600 ? "0 16px" : "0"
                }}>
                    Übersicht der Kunden und deren Produkte
                </h3>
                
                <div style={{ maxWidth: window.innerWidth < 600 ? "95%" : "80%", margin: "auto" }}>
                    {/* Main Action Bar */}
                    <Paper 
                        elevation={3} 
                        sx={{ 
                            p: { xs: 1.5, sm: 2.5 }, 
                            mb: { xs: 2, sm: 3 }, 
                            bgcolor: "white",
                            borderRadius: 3,
                            boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)"
                        }}
                    >
                        <Box sx={{ display: "flex", flexDirection: { xs: 'column', md: 'row' }, gap: 2, alignItems: { xs: 'stretch', md: 'center' }, justifyContent: "space-between" }}>
                            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: 2, alignItems: { xs: 'stretch', sm: 'center' }, flexWrap: "wrap", flex: 1 }}>
                                <TextField
                                    size="medium"
                                    placeholder="Kunden suchen..."
                                    value={this.state.searchUserInTable || ''}
                                    onChange={(e) => this.setState({ searchUserInTable: e.target.value })}
                                    fullWidth={window.innerWidth < 600}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Search sx={{ color: "#2e7d32" }} />
                                            </InputAdornment>
                                        ),
                                    }}
                                    sx={{ 
                                        minWidth: { xs: '100%', sm: 250 },
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '10px',
                                            '&:hover fieldset': {
                                                borderColor: '#2e7d32',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#2e7d32',
                                            },
                                        }
                                    }}
                                />
                                {this.state.selectedCustomers.length > 0 && (
                                    <Chip 
                                        label={`${this.state.selectedCustomers.length} Kunde${this.state.selectedCustomers.length !== 1 ? 'n' : ''} ausgewählt`}
                                        sx={{ 
                                            fontWeight: 600,
                                            bgcolor: '#e8f5e9',
                                            color: '#2e7d32',
                                            border: '2px solid #2e7d32'
                                        }}
                                    />
                                )}
                            </Box>
                            
                            <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 1.5, sm: 1.5 }, alignItems: "center", width: { xs: '100%', md: 'auto' } }}>
                                <Button 
                                    variant="outlined"
                                    startIcon={<GetApp sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />}
                                    onClick={this.RetrieveExcelFile}
                                    disabled={this.state.downloadingExcel}
                                    fullWidth={window.innerWidth < 600}
                                    sx={{
                                        borderColor: '#2e7d32',
                                        color: '#2e7d32',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: { xs: '0.85rem', sm: '0.875rem' },
                                        borderRadius: '10px',
                                        '&:hover': {
                                            borderColor: '#1b5e20',
                                            bgcolor: '#e8f5e9'
                                        }
                                    }}
                                >
                                    {this.state.downloadingExcel ? "Lädt..." : "Sofort herunterladen"}
                                </Button>
                                
                                <Button 
                                    variant="contained"
                                    startIcon={<FileDownload sx={{ display: { xs: 'none', sm: 'inline-flex' } }} />}
                                    onClick={this.openBulkDownloadFromParent}
                                    fullWidth={window.innerWidth < 600}
                                    sx={{
                                        bgcolor: '#2e7d32',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        fontSize: { xs: '0.85rem', sm: '0.875rem' },
                                        borderRadius: '10px',
                                        '&:hover': {
                                            bgcolor: '#1b5e20'
                                        }
                                    }}
                                >
                                    Auswahl herunterladen
                                </Button>
                                
                                <IconButton 
                                    onClick={this.handleMenuOpen}
                                    sx={{ 
                                        border: 1, 
                                        borderColor: 'divider',
                                        display: { xs: 'none', sm: 'inline-flex' },
                                        '&:hover': { bgcolor: 'action.hover' }
                                    }}
                                >
                                    <MoreVert />
                                </IconButton>
                                
                                <Button 
                                    variant="outlined"
                                    fullWidth
                                    onClick={this.handleMenuOpen}
                                    sx={{
                                        display: { xs: 'flex', sm: 'none' },
                                        borderColor: '#2e7d32',
                                        color: '#2e7d32',
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        borderRadius: '10px'
                                    }}
                                >
                                    Weitere Aktionen
                                </Button>
                                
                                <Menu
                                    anchorEl={this.state.anchorEl}
                                    open={Boolean(this.state.anchorEl)}
                                    onClose={this.handleMenuClose}
                                    elevation={3}
                                    PaperProps={{
                                        sx: {
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                                            minWidth: 280
                                        }
                                    }}
                                >
                                    <MenuItem 
                                        onClick={() => { this.handleMenuClose(); this.setState({ createUser: true }); }}
                                        sx={{
                                            '&:hover': { bgcolor: '#e8f5e9' }
                                        }}
                                    >
                                        <ListItemIcon>
                                            <PersonAdd fontSize="small" sx={{ color: '#2e7d32' }} />
                                        </ListItemIcon>
                                        <ListItemText>Kunde hinzufügen</ListItemText>
                                    </MenuItem>
                                    <MenuItem 
                                        onClick={() => { this.handleMenuClose(); this.ConfirmAllOpenOrders(); }}
                                        sx={{
                                            '&:hover': { bgcolor: '#e8f5e9' }
                                        }}
                                    >
                                        <ListItemIcon>
                                            <CheckCircle fontSize="small" color="success" />
                                        </ListItemIcon>
                                        <ListItemText>Alle offenen Bestellungen bestätigen</ListItemText>
                                    </MenuItem>
                                    <MenuItem 
                                        onClick={() => { this.handleMenuClose(); this.DeleteAllOrders(); }}
                                        sx={{
                                            '&:hover': { bgcolor: '#ffebee' }
                                        }}
                                    >
                                        <ListItemIcon>
                                            <DeleteOutline fontSize="small" color="error" />
                                        </ListItemIcon>
                                        <ListItemText>Alle Bestellungen löschen</ListItemText>
                                    </MenuItem>
                                </Menu>
                            </Box>
                        </Box>
                    </Paper>

                    {/* Customer Table */}
                    <CustomerProductsTable 
                        ref={this.customerTableRef}
                        allOrders={this.state.allOrders} 
                        customers={this.FilterUsers()} 
                        products={this.state.products}
                        onSelectionChange={this.handleCustomerSelectionChange}
                        externalSelectedCustomers={this.state.selectedCustomers}
                    />
                </div>

                <CreateUserPopup show={this.state.createUser} onClose={() => this.setState({ createUser: false })} />
                <BulkDownloadSheetPopup
                    show={this.state.showBulkDownload}
                    selectedCustomers={this.state.selectedCustomers}
                    allCustomers={this.state.allOrders}
                    products={this.state.products}
                    onClose={() => this.setState({ showBulkDownload: false })}
                    onSelectionChange={(newSelection) => this.setState({ selectedCustomers: newSelection || [] })}
                />
            </div>
        )
    }
}

export default DashboardAlleKunden;